export const API_ROUTES = {
  BASE_URL: 'https://europe-west3-arkayl.cloudfunctions.net/arkayl/v1',
  SEND_EMAIL: '/send-email'
}
